import React from 'react'
import CustomCalendarSVG from './CustomCalendarSVG';

const DatePicker = ({date, setDate, isMobile = false, onChange = null}) => {
    return (
        <div className="relative flex w-full justify-center rounded-sm dark:text-customWhite dark:border-custom_dark_primary mt-1">
            <input
                className={`dark:bg-white/5 bg-customBlack/5 dark:text-customWhite dark:border-custom_dark_primary text-gray-900 px-5 py-1 rounded-md border border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-100 transition duration-300 ease-in-out w-full cursor-pointer ${isMobile ? 'text-xs' : 'text-sm'}`}
                type="date"
                value={date}
                onChange={onChange || (e => setDate(e.target.value))}
            />
            <CustomCalendarSVG />
        </div>
    )
}

export default DatePicker;